/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Contact_Reason_Built_DetailInputs */

const en_marketing_contact_reason_built_detail = /** @type {(inputs: Marketing_Contact_Reason_Built_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JXD ships products on Onyx in weeks, with a full handover at the end.`)
};

const es_marketing_contact_reason_built_detail = /** @type {(inputs: Marketing_Contact_Reason_Built_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JXD lanza productos sobre Onyx en semanas, con una entrega completa al final.`)
};

const fr_marketing_contact_reason_built_detail = /** @type {(inputs: Marketing_Contact_Reason_Built_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JXD livre des produits sur Onyx en quelques semaines, avec un transfert complet à la fin.`)
};

/**
* | output |
* | --- |
* | "JXD ships products on Onyx in weeks, with a full handover at the end." |
*
* @param {Marketing_Contact_Reason_Built_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_contact_reason_built_detail = /** @type {((inputs?: Marketing_Contact_Reason_Built_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Contact_Reason_Built_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_contact_reason_built_detail(inputs)
	if (locale === "es") return es_marketing_contact_reason_built_detail(inputs)
	return fr_marketing_contact_reason_built_detail(inputs)
});